module.exports = __webpack_public_path__ + "01_glasses_brown.d89d8edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer4/01_glasses_brown.png
// module id = eueX
// module chunks = 0